/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Declare Variable
 */
const defaultCategoriesState = null
const defaultSelectedCategoryState = null
const defaultselectedSetCategoryState = null

/**
 * Export
 */
export const categories = handleActions({
  GET_CATEGORIES: (state, action) => {
    return action.payload
  },
}, defaultCategoriesState)

export const selectedCategory = handleActions({
  SELECT_CATEGORY: (state, action) => {
    return action.payload
  },
}, defaultSelectedCategoryState)

export const selectedSetCategory = handleActions({
  SELECT_SET_CATEGORY: (state, action) => {
    return action.payload
  },
}, defaultselectedSetCategoryState)

export default {
  categories,
  selectedCategory,
  selectedSetCategory,
}



// WEBPACK FOOTER //
// ./src/reducers/components/category.js